module.exports = __webpack_public_path__ + "static/orc_axebeak_attacks_halfling-2698095f5f17185cbfa776193f5ec19a.jpg";